import React from 'react'
import PropTypes from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import BaseTemplate from 'components/templates/BaseTemplate'
import StudyFieldList from 'components/study_fields/StudyFieldList'
import intl from 'react-intl-universal'
import { Container, Row, SVGIcon, NumberSpot } from 'components/qstrap'

const StudyFields = ({ studyFields }) => (
  <BaseTemplate noBreadcrumb useNewHeader>
    <section className="study-fields blue-darker">
      <div className="wrapper">
        <Container>
          <Row>
            <div>
              <div className="widget hidden-sm-down">
                <SVGIcon name="common-course" className="pull-left m-r-sm icon-title" size="lg" />
                <span> {intl.get('study_fields.search_schools_by')} </span>
                <h2> {intl.get('study_fields.study_field')} </h2>
              </div>
            </div>

            <div className="study-field-items">
              {studyFields.map(studyField => (
                <div key={studyField.id} className="study-field-box list-group-subgroup">
                  <div className="title">
                    <div className="hidden-sm-up"><a href="#" data-toggle="list-group-subgroup"><h4>{studyField.name}</h4></a></div>
                    <div className="hidden-sm-down"><h4>{studyField.name}</h4></div>
                    <NumberSpot className="hidden-sm-up" number={studyField.children.length} />
                  </div>

                  <div className="row boxed-link-container list-group">
                    <StudyFieldList studyFields={studyField.children} />
                  </div>
                </div>
              ))}
            </div>
          </Row>
        </Container>
      </div>
    </section>

  </BaseTemplate>
)

StudyFields.propTypes = {
  studyFields: PropTypes.array,
}

StudyFields.defaultProps = {
  studyFields: [],
}

export { StudyFields }
export default branch({
  studyFields: ['serverProps', 'studyFields'],
}, StudyFields)
